let id = 0;

export function getUniqueId() {
    id++;

    return String(id);
}
